export const charts = ["#BCAFE6", "#7C60D9", "#46367A", "#A9DDA8", "#6DCC6A", "#FFEAAD", "#FFD65C", "#F9BF78", "#F69B2C", "#EDB8B4", "#E45C52"];